/**
 * Normalizes a phone number to E.164 format for consistent matching.
 * Assumes US phone numbers if no country code is provided.
 *
 * Examples:
 *   "(555) 555-5555" -> "+15555555555"
 *   "555-555-5555" -> "+15555555555"
 *   "5555555555" -> "+15555555555"
 *   "+15555555555" -> "+15555555555"
 *   "15555555555" -> "+15555555555"
 */
export function normalizePhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return '';

  const digitsOnly = phoneNumber.replace(/\D/g, '');

  if (digitsOnly.length === 10) {
    return `+1${digitsOnly}`;
  }

  if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    return `+${digitsOnly}`;
  }

  if (phoneNumber.startsWith('+')) {
    return `+${digitsOnly}`;
  }

  return digitsOnly;
}

/**
 * Formats a phone number for display as (XXX) XXX-XXXX.
 * Formats as user types for a better UX.
 *
 * Examples:
 *   "555" -> "555"
 *   "5555555555" -> "(555) 555-5555"
 *   "15555555555" -> "+15555555555"
 */
export function formatPhoneNumber(value: string): string {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  if (digits.length <= 10) {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  return `+${digits}`;
}
